/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import { ENV } from '@/env';
import { getToken, setToken } from './token';
import qs from 'qs';
import axios from 'axios';
import { getCurrentSubdomain } from './Subdomain';
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
            setToken(data?.userToken, 'userToken');
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker({ userToken: getToken('userToken') }))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            const URL_SUBDOMAIN = getCurrentSubdomain();
            if (type === ContentType.FormData &&
                body &&
                body !== null &&
                typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                const formData = this.createFormData(body);
            }
            if (!path.includes('/account')) {
                const tok = getToken();
                if (tok) {
                    requestParams.headers = requestParams.headers || {};
                    requestParams.headers.Authorization = `Bearer ${tok}`;
                }
            }
            const response = await this.instance.request({
                ...requestParams,
                headers: {
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {}),
                    ...(requestParams.headers || {}),
                    ...({ 'X-Product': URL_SUBDOMAIN }),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
            if (response.headers['x-session-token'] && !path.includes('/account')) {
                // If the proxy minted a new token, store it
                const newTok = response.headers['x-session-token'];
                if (newTok)
                    setToken(newTok, 'session_token');
            }
            if (response.status >= 200 && response.status < 300 && response.data.data) {
                return response.data ?? [];
            }
            if (response.status >= 200 && response.status < 300 && response.data) {
                return response.data ?? [];
            }
            return response;
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: ENV.BACKEND_URL,
            withCredentials: true,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.instance.defaults.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
/**
 * @title Phoenix ChangiRecommends API
 * @version 1.0.0@dev
 * @baseUrl http://changirecommends.phoenix.local
 *
 * New structure for OPEN API
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.api = {
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsCarousels
             * @summary Getting carousels for ChangiRecommends landing page
             * @request GET:/content/carousels
             * @secure
             * @response `200` `(ContentCarouselCarouselSchema)[]` Carousels
             */
            ChangiRecommendsCarousels: (params = {}) => this.request({
                path: `/content/carousels`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsCheckoutConfirmationCmsContent
             * @summary Getting cms content for Checkout confirmation page
             * @request GET:/content/checkout-confirmation-cms-content
             * @secure
             * @response `200` `{ content?: string }` Cms content
             */
            ChangiRecommendsCheckoutConfirmationCmsContent: (params = {}) => this.request({
                path: `/content/checkout-confirmation-cms-content`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name Login
             * @summary MyAccount: Log in user
             * @request POST:/account/login
             * @secure
             * @response `200` `{ userToken?: string, uuid?: string }` User successfully logged in
             * @response `401` `{ message?: string }` Wrong credentials response
             * @response `403` `{ message?: string }` Your email address is not verified
             */
            login: (data, params = {}) => this.request({
                path: `/account/login`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name Logout
             * @summary MyAccount: Log out user
             * @request POST:/account/logout
             * @secure
             * @response `200` `{ message?: string }` Successfully logged out
             * @response `401` `{ message?: string }` Unauthorized
             */
            logout: (params = {}) => this.request({
                path: `/account/logout`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsBanner
             * @summary Get banner data
             * @request GET:/banner
             * @secure
             * @response `200` `(ChangiRecommendsBannerSchema)[]` Banner
             */
            ChangiRecommendsBanner: (params = {}) => this.request({
                path: `/banner`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsPromoBanner
             * @summary Get promo banner data
             * @request GET:/content/banners
             * @secure
             * @response `200` `(ChangiRecommendsPromoBannerSchema)[]` Banner
             */
            ChangiRecommendsPromoBanner: (params = {}) => this.request({
                path: `/content/banners`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsBestsellersList
             * @summary Get bestsellers for selected Category
             * @request GET:/bestrec/bestsellers/{category}
             * @secure
             * @response `200` `void` Bestsellers
             */
            ChangiRecommendsBestsellersList: ({ category, ...query }, params = {}) => this.request({
                path: `/bestrec/bestsellers/${category}`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsAddToCart
             * @summary ChangiRecommendsCart: Add to cart
             * @request POST:/sales/add-to-cart
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: object }` Product has been added into shopping cart.
             * @response `403` `{ status_code?: string, message?: string, data?: object }` Required quantity is not available.
             */
            ChangiRecommendsAddToCart: (data, params = {}) => this.request({
                path: `/sales/add-to-cart`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsGetCartItems
             * @summary Getting shopping cart items
             * @request GET:/sales/get-cart-items
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsCartSchema)[] }` Success
             */
            ChangiRecommendsGetCartItems: (params = {}) => this.request({
                path: `/sales/get-cart-items`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsUpdateCartQuantity
             * @summary ChangiRecommendsCart: Update Cart Quantity
             * @request POST:/sales/update-cart-quantity
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: object }` Quantity has been updated.
             * @response `400` `{ status_code?: string, message?: string, data?: object }` Quantity must be 1 or greater.
             * @response `403` `{ status_code?: string, message?: string, data?: object }` Required quantity is not available.
             */
            ChangiRecommendsUpdateCartQuantity: (data, params = {}) => this.request({
                path: `/sales/update-cart-quantity`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsUpdateCartUnit
             * @summary ChangiRecommendsCart: Update Cart Unit
             * @request POST:/sales/update-cart-unit
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: object }` Product has been updated.
             * @response `403` `{ status_code?: string, message?: string, data?: object }` Required quantity is not available.
             */
            ChangiRecommendsUpdateCartUnit: (data, params = {}) => this.request({
                path: `/sales/update-cart-unit`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsRemoveCartItem
             * @summary ChangiRecommendsCart: Remove Cart Item
             * @request POST:/sales/remove-cart-item
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: object }` Product has been removed from shopping cart.
             */
            ChangiRecommendsRemoveCartItem: (data, params = {}) => this.request({
                path: `/sales/remove-cart-item`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsUpdateCartUponLogin
             * @summary ChangiRecommendsCart: Update Cart Upon Login
             * @request PUT:/sales/update-cart-upon-login
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsCartSchema)[] }` Success
             */
            ChangiRecommendsUpdateCartUponLogin: (params = {}) => this.request({
                path: `/sales/update-cart-upon-login`,
                method: 'PUT',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsFLushSessionUponLogout
             * @summary ChangiRecommendsCart: Flush Session Upon Logout
             * @request POST:/sales/flush-session-upon-logout
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsEmptyCartSchema)[] }` Success
             */
            ChangiRecommendsFLushSessionUponLogout: (params = {}) => this.request({
                path: `/sales/flush-session-upon-logout`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Sales
             * @name ChangiRecommendsRemoveAllCartItemsUponCheckout
             * @summary ChangiRecommendsCart: Remove All Cart Items Upon Checkout
             * @request DELETE:/sales/remove-all-cart-items-upon-checkout
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsEmptyCartSchema)[] }` Success
             */
            ChangiRecommendsRemoveAllCartItemsUponCheckout: (params = {}) => this.request({
                path: `/sales/remove-all-cart-items-upon-checkout`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name ChangePassword
             * @summary MyAccount: Change user's password
             * @request POST:/account/change-password
             * @secure
             * @response `200` `{ message?: string }` User password successfully changed
             * @response `401` `void` Unauthorized
             * @response `422` `ValidationFailed` Validation failed
             */
            changePassword: (data, params = {}) => this.request({
                path: `/account/change-password`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Customer
             * @name ChangiRecommendsRewardPoints
             * @summary ChangiRecommendsRewardPoints: Get customer reward points
             * @request GET:/account/reward-points
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsCustomerRewardPointsSchema)[] }` Success
             * @response `400` `{ status_code?: string, message?: string }` Please login.
             */
            ChangiRecommendsRewardPoints: (params = {}) => this.request({
                path: `/account/reward-points`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Customer
             * @name ChangiRecommendsRewardPointsAccountBanner
             * @summary ChangiRecommendsRewardPoints: Get customer reward points account banner
             * @request GET:/account/reward-points/account-banner
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsCustomerRewardPointsAccountBannerSchema)[] }` Success
             * @response `400` `{ status_code?: string, message?: string }` Please login.
             */
            ChangiRecommendsRewardPointsAccountBanner: (params = {}) => this.request({
                path: `/account/reward-points/account-banner`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dashboard
             * @name ChangiRecommendsDashboardOrdersList
             * @request GET:/account/orders
             * @secure
             * @response `200` `{ data?: (OrderSchema)[], meta?: (Pagination)[] }` Products
             */
            ChangiRecommendsDashboardOrdersList: (query, params = {}) => this.request({
                path: `/account/orders`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dashboard
             * @name ChangiRecommendsDashboardOrderView
             * @request GET:/account/orders/{uuid}
             * @secure
             * @response `200` `(OrderSchema)[]` Orders Details
             */
            ChangiRecommendsDashboardOrderView: (uuid, params = {}) => this.request({
                path: `/account/orders/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dashboard
             * @name ChangiRecommendsDashboardOrderLast
             * @request GET:/account/order-last
             * @secure
             * @response `200` `(OrderSchema)[]` Orders Details
             */
            ChangiRecommendsDashboardOrderLast: (params = {}) => this.request({
                path: `/account/order-last`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dashboard
             * @name ChangiRecommendsOrderTrackingInformation
             * @request GET:/account/tracking/{uuid}
             * @secure
             * @response `200` `{ code?: number, message?: string, tracking?: OrderTrackingSchema }` Order Tracking Details
             */
            ChangiRecommendsOrderTrackingInformation: (uuid, params = {}) => this.request({
                path: `/account/tracking/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dashboard
             * @name ChangiRecommendsOrderByCode
             * @request POST:/account/search/{code}
             * @secure
             * @response `200` `{ code?: number, message?: string, tracking?: OrderSchema }` Order Tracking Details
             */
            ChangiRecommendsOrderByCode: (code, data, params = {}) => this.request({
                path: `/account/search/${code}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name ChangiRecommendsForgotPassword
             * @summary MyAccount: User forgot password
             * @request POST:/account/forgot
             * @secure
             * @response `200` `void` Reset password link sent on your email id.
             * @response `422` `ValidationFailed` Validation failed
             */
            ChangiRecommendsForgotPassword: (data, params = {}) => this.request({
                path: `/account/forgot`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsCarouselFaqs
             * @summary Getting faqs for ChangiRecommends landing page
             * @request GET:/content/faqs
             * @secure
             * @response `200` `(ChangiRecommendsFaqSchema)[]` CarouselFaqs
             */
            ChangiRecommendsCarouselFaqs: (params = {}) => this.request({
                path: `/content/faqs`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsCarouselBrands
             * @summary Getting carousel brands for ChangiRecommends landing page
             * @request GET:/content/homecarouselbrands
             * @secure
             * @response `200` `(ChangiRecommendsBrandSchema)[]` CarouselBrands
             */
            ChangiRecommendsCarouselBrands: (params = {}) => this.request({
                path: `/content/homecarouselbrands`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsAllBrands
             * @summary Getting all brands for ChangiRecommends landing page
             * @request GET:/content/all-brands
             * @secure
             * @response `200` `(ChangiRecommendsBrandSchema)[]` AllBrands
             */
            ChangiRecommendsAllBrands: (params = {}) => this.request({
                path: `/content/all-brands`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsSLiders
             * @summary Getting sliders for ChangiRecommends landing page
             * @request GET:/content/homesliders
             * @secure
             * @response `200` `(ChangiRecommendsSliderSchema)[]` Sliders
             */
            ChangiRecommendsSLiders: (params = {}) => this.request({
                path: `/content/homesliders`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsPromoBars
             * @summary Getting Promo Bars for ChangiRecommends landing page
             * @request GET:/content/promobars
             * @secure
             * @response `200` `(ChangiRecommendsPromoBarSchema)[]` Promo Bars
             */
            ChangiRecommendsPromoBars: (params = {}) => this.request({
                path: `/content/promobars`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsCategoryNavigations
             * @summary Getting category navigations for ChangiRecommends landing page
             * @request GET:/content/categorynavigations
             * @secure
             * @response `200` `(ChangiRecommendsCategoryNavigationSchema)[]` CategoryNavigations
             */
            ChangiRecommendsCategoryNavigations: (params = {}) => this.request({
                path: `/content/categorynavigations`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsSpotlights
             * @summary Getting spotlights for ChangiRecommends landing page
             * @request GET:/content/homespotlights
             * @secure
             * @response `200` `(ChangiRecommendsSpotlightSchema)[]` Spotlights
             */
            ChangiRecommendsSpotlights: (params = {}) => this.request({
                path: `/content/homespotlights`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsGalleries
             * @summary Getting galleries for ChangiRecommends landing page
             * @request GET:/content/homegalleries
             * @secure
             * @response `200` `(ChangiRecommendsGallerySchema)[]` Galleries
             */
            ChangiRecommendsGalleries: (params = {}) => this.request({
                path: `/content/homegalleries`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name CreateChangiRecommendsOrder
             * @summary Create new order in ChangiRecommends
             * @request POST:/order/create
             * @secure
             * @response `201` `OrderChangiRecommendsOrderResponseSchema` Created
             * @response `401` `{ message?: string }` Information about unauthorized request
             * @response `422` `ValidationFailed` Unprocessable Entity
             */
            createChangiRecommendsOrder: (data, params = {}) => this.request({
                path: `/order/create`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Order
             * @name ChangiRecommendsOrderDiscounts
             * @summary Get order discounts
             * @request GET:/shop/get-order-discounts/{uuid}
             * @secure
             * @response `200` `OrderChangiRecommendsOrderDiscountsSchema` Get order discounts
             */
            ChangiRecommendsOrderDiscounts: ({ uuid, ...query }, params = {}) => this.request({
                path: `/shop/get-order-discounts/${uuid}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name ChangiRecommendsFreeShippingOrderAmount
             * @summary Get order amount needed to get free shipping
             * @request GET:/shop/free-shipping-order-amount
             * @secure
             * @response `200` `({ state?: string, result?: number })[]` Get free shipping amount
             */
            ChangiRecommendsFreeShippingOrderAmount: (params = {}) => this.request({
                path: `/shop/free-shipping-order-amount`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name ChangiRecommendsOrderPaymentStatus
             * @summary Get order payment status
             * @request GET:/order/{orderUuid}/payment-status
             * @secure
             * @response `200` `OrderOrderPaymentStatus` Order payment status
             * @response `404` `void` Order not found
             */
            ChangiRecommendsOrderPaymentStatus: (orderUuid, params = {}) => this.request({
                path: `/order/${orderUuid}/payment-status`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsProductBrandHighlightedList
             * @summary Highlighted Product brands
             * @request GET:/brands/{category}
             * @secure
             * @response `200` `void` Highlighted
             */
            ChangiRecommendsProductBrandHighlightedList: ({ category, ...query }, params = {}) => this.request({
                path: `/brands/${category}`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name ChangiRecommendsBrandsByCatalog
             * @summary Getting brands available in current category
             * @request GET:/shop/brands/{categoryUuid}
             * @secure
             * @response `200` `(ProductBrand)[]` List of brands in that categories
             */
            ChangiRecommendsBrandsByCatalog: (categoryUuid, params = {}) => this.request({
                path: `/shop/brands/${categoryUuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name GetCategoryAttributes
             * @summary Get category attributes
             * @request GET:/shop/product-category/{uuid}
             * @secure
             * @response `200` `(ProductCategoryAttribute)[]` Attributes
             */
            getCategoryAttributes: (uuid, params = {}) => this.request({
                path: `/shop/product-category/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name ChangiRecommendsCatalogProductsList
             * @summary Getting products from get_it catalog
             * @request GET:/products
             * @secure
             * @response `200` `{ data?: (ProductSchema)[], meta?: object }` Products
             */
            ChangiRecommendsCatalogProductsList: (query, params = {}) => this.request({
                path: `/products`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shop
             * @name ChangiRecommendsCatalogProduct
             * @summary Get product from the get_it catalog
             * @request GET:/shop/product/{uuid}
             * @secure
             * @response `200` `ProductSchema` Products
             */
            ChangiRecommendsCatalogProduct: (uuid, params = {}) => this.request({
                path: `/shop/product/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Product
             * @name ChangiRecommendsProductSearch
             * @summary Search product by name, type, category and attributes
             * @request GET:/search
             * @secure
             * @response `200` `{ data?: (ProductSchema)[], meta?: object }` Products
             */
            ChangiRecommendsProductSearch: (query, params = {}) => this.request({
                path: `/search`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Content
             * @name ChangiRecommendsRecommendedList
             * @summary Get recommended for selected Category
             * @request GET:/bestrec/recommended/{category}
             * @secure
             * @response `200` `void` Recommended
             */
            ChangiRecommendsRecommendedList: ({ category, ...query }, params = {}) => this.request({
                path: `/bestrec/recommended/${category}`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name Register
             * @summary MyAccount: Register user
             * @request POST:/register
             * @secure
             * @response `201` `UserCreatedResponse` User successfully created
             * @response `422` `ValidationFailed` Validation failed
             */
            register: (data, params = {}) => this.request({
                path: `/account/register`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name ResendRegisterVerificationEmail
             * @summary MyAccount: Resend register verification email
             * @request POST:/resend-register-verification-email/{userUuid}
             * @secure
             * @response `201` `{ status?: number, message?: string, data?: string }` Email successfully sent
             */
            resendRegisterVerificationEmail: (userUuid, params = {}) => this.request({
                path: `/account/resend-register-verification-email/${userUuid}`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name CreateUserAddress
             * @summary Add new user billing address
             * @request POST:/account/add-address
             * @secure
             * @response `201` `{ status_code?: number, message?: string, data?: object }` Information about successfully created user address
             * @response `401` `{ message?: string }` Information about unauthorized request
             * @response `422` `ValidationFailed` Unprocessable Entity
             */
            createUserAddress: (data, params = {}) => this.request({
                path: `/account/add-address`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name UpdateUserAddress
             * @summary Update user billing address
             * @request PUT:/account/update-address/{addressId}
             * @secure
             * @response `200` `{ status_code?: number, message?: string, data?: object }` Information about successfully updated user address
             * @response `401` `{ message?: string }` Information about unauthorized request
             * @response `404` `AddressDoesNotBelongToUser` Address does not belong to authenticated user
             */
            updateUserAddress: (addressId, data, params = {}) => this.request({
                path: `/account/update-address/${addressId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name SetUserAddressAsDefault
             * @summary Set selected user billing address as default
             * @request PUT:/account/set-address-as-default/{addressId}
             * @secure
             * @response `200` `{ status_code?: number, message?: string, data?: object }` Information about successfully updated user address
             * @response `401` `{ message?: string }` Information about unauthorized request
             * @response `404` `AddressDoesNotBelongToUser` Address does not belong to authenticated user
             */
            setUserAddressAsDefault: (addressId, params = {}) => this.request({
                path: `/account/set-address-as-default/${addressId}`,
                method: 'PUT',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name DeleteUserAddress
             * @summary Delete selected user address
             * @request DELETE:/account/delete-address/{addressId}
             * @secure
             * @response `204` `void` Information about successfully deleted user address
             * @response `401` `{ message?: string }` Information about unauthorized request
             * @response `404` `AddressDoesNotBelongToUser` Address does not belong to authenticated user
             */
            deleteUserAddress: (addressId, params = {}) => this.request({
                path: `/account/delete-address/${addressId}`,
                method: 'DELETE',
                secure: true,
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name GetUserData
             * @summary Get logged in user data
             * @request GET:/account/user-data
             * @secure
             * @response `200` `UserDetailsSchema` User account details
             * @response `401` `{ message?: string }` Unauthorized
             */
            getUserData: (params = {}) => this.request({
                path: `/account/user-data`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name UpdateUserData
             * @summary Update logged in user data
             * @request PATCH:/account/update-user-data
             * @secure
             * @response `200` `{ message?: string }` Information about successful update
             * @response `400` `{ message?: string }` Bad Request
             * @response `401` `{ message?: string }` Unauthorized
             * @response `422` `ValidationFailed` Validation failed
             */
            updateUserData: (data, params = {}) => this.request({
                path: `/account/update-user-data`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Account
             * @name ChangiRecommendsAddToWishlist
             * @summary ChangiRecommendsWishlist: Add to Wishlist
             * @request POST:/account/add-to-wishlist
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsWishlistItemSchema)[] }` Product has been added into wishlist.
             * @response `400` `{ status_code?: string, message?: string }` Please login.
             * @response `403` `{ status_code?: string, message?: string, data?: (ChangiRecommendsWishlistItemSchema)[] }` Product is already in wishlist.
             */
            ChangiRecommendsAddToWishlist: (data, params = {}) => this.request({
                path: `/account/add-to-wishlist`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Account
             * @name ChangiRecommendsGetWishlistItems
             * @summary ChangiRecommendsWishlist: Get wishlist items
             * @request GET:/account/get-wishlist-items
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsWishlistItemSchema)[] }` Success
             * @response `400` `{ status_code?: string, message?: string }` Please login.
             */
            ChangiRecommendsGetWishlistItems: (params = {}) => this.request({
                path: `/account/get-wishlist-items`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Account
             * @name ChangiRecommendsRemoveWishlistItem
             * @summary ChangiRecommendsWishlist: Remove Wishlist Item
             * @request POST:/account/remove-wishlist-item
             * @secure
             * @response `200` `{ status_code?: string, message?: string, data?: (ChangiRecommendsWishlistItemSchema)[] }` Product has been removed from wishlist.
             */
            ChangiRecommendsRemoveWishlistItem: (data, params = {}) => this.request({
                path: `/account/remove-wishlist-item`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * @description Is customer subscribed to newsletter
             *
             * @tags Customer
             * @name ChangiRecommendsNewsletterIsSubscribed
             * @request POST:/account/is-subscribed
             * @secure
             * @response `200` `{ subscribed?: boolean, amount?: number }` Results of check
             * @response `402` `void` Incorrect email passed
             */
            ChangiRecommendsNewsletterIsSubscribed: (query, params = {}) => this.request({
                path: `/account/is-subscribed`,
                method: 'POST',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Is customer subscribed to newsletter
             *
             * @tags Customer
             * @name ChangiRecommendsNewsletterSubscribe
             * @request POST:/account/newsletter-subscribe
             * @secure
             * @response `200` `{ status_code?: string; message?: string; data?: string }` Success
             * @response `400` `{ status_code?: string; message?: string }` Error
             */
            ChangiRecommendsNewsletterSubscribe: (data, params = {}) => this.request({
                path: `/account/subscribe`,
                method: 'POST',
                body: data,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Account
             * @name checkApiHubCallback
             * @summary Check API Hub callback
             * @request POST:/api/apihub/check-callback
             * @secure
             * @response `200` `{ status_code?: string; message?: string; data?: string }` Success
             * @response `401` `{ message?: string }` Unauthorized
             */
            checkApiHubCallback: (params = {}) => this.request({
                path: `/sales/apihub-check-callback`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
                body: params
            }),
            /**
             * Exchange CIAM code for app token
             *
             * @tags User
             * @name ciamExchange
             * @summary Exchange CIAM code for app token
             * @request POST:/account/ciam-exchange
             * @secure
             * @response `200` `{ userToken?: string }` Success
             */
            ciamExchange: (data, params = {}) => this.request({
                path: `/ciam/exchange`,
                method: 'POST',
                body: data,
                secure: true,
                format: 'json',
                ...params,
            }),
        };
    }
}
